import { render, staticRenderFns } from "./Professions.vue?vue&type=template&id=49c3f886&scoped=true"
import script from "./Professions.vue?vue&type=script&lang=js"
export * from "./Professions.vue?vue&type=script&lang=js"
import style0 from "./Professions.vue?vue&type=style&index=0&id=49c3f886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c3f886",
  null
  
)

export default component.exports